import * as React from "react";
import { useState, useEffect, useRef, useCallback } from "react";
import AutoComplete from "./AutoComplete";
import {
  CallService,
  formatDate,
  modalAlert,
  getAllCompany,
} from "../Js/Script";
import "../Css/Search.css";
import { useNavigate } from "react-router-dom";
import { UseDepartment } from "../Js/Context/DepartmentCntx";
import { UseUser } from "../Js/Context/userCntx";
import { UseCategory } from "../Js/Context/CategoryCntx ";
import { UseOrganizaton } from "../Js/Context/OrganizationCntx";
import { SetSearch, UseSearch } from "../Js/Context/SearchCntx";
//material-ui
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
export default function Search(props) {
  const Importance = [
    { title: "بحرانی", id: "1" },
    { title: "بالا", id: "2" },
    { title: "عادی", id: "3" },
    { title: "پایین", id: "4" },
  ];
  const TicketSearchStatus = [
    { title: "باز", id: "1" },
    { title: "بسته", id: "2" },
  ];
  const TicketAnswerSearchStatus = [
    { title: "در حال بررسی", id: "3", type: "pending" },
    { title: "پاسخ ایجاد کننده", id: "2", type: "createrAnswered" },
    { title: "پاسخ داده شده", id: "1", type: "receiverAnswered" },
  ];
  const Kind = [
    { title: "توسعه", id: "1", type: "develop" },
    { title: "باگ", id: "2", type: "bug" },
    { title: "پیگیری فناوران", id: "1", type: "fanavaran" },
  ];

  const navigate = useNavigate();
  const stDepartment = UseDepartment();
  const stOrganization = UseOrganizaton();
  const stSearch = UseSearch();
  // const stKind = UseSearch();
  const setStSearch = SetSearch();
  const stUser = UseUser();
  const stCategory = UseCategory();
  const { rowNum } = props;
  const [stReciverUser, setStReciverUser] = useState([]);
  const showElement = props.showElement;
  const tags = props.tags || [];
  const multiStSearch = UseSearch();
  const setMultiStSearch = SetSearch();

  const initialValue = Array.isArray(multiStSearch.TicketRecipientCompany)
    ? multiStSearch.TicketRecipientCompany
    : multiStSearch.TicketRecipientCompany
      ? [multiStSearch.TicketRecipientCompany]
      : [];

  useEffect(() => {
    const reciverUser = new Set(props.reciverUser);
    reciverUser.forEach((user) => {
      setStReciverUser((prev) => ({
        ...prev,
        reciverUser: Array.isArray(prev.reciverUser)
          ? [
              ...prev.reciverUser,
              {
                targetUserId: parseInt(
                  user.substring(user.lastIndexOf("-") + 1),
                ),
                targetUserName: user.substring(0, user.lastIndexOf("-")),
              },
            ]
          : [
              {
                targetUserId: parseInt(
                  user.substring(user.lastIndexOf("-") + 1),
                ),
                targetUserName: user.substring(0, user.lastIndexOf("-")),
              },
            ],
      }));
    }, []);
  }, []);
  //send search object to specific component...
  const getSearched = () => {
    const newSearchObject = { ...stSearch.searchedObject };

    if (stSearch.SearchCategory)
      newSearchObject.categoryId = stSearch.SearchCategory.categoryId;
    if (stSearch.TicketCreatedUser)
      newSearchObject.TicketCreatedUser = stSearch.TicketCreatedUser;
    if (stSearch.ticketId)
      newSearchObject.ticketId = parseInt(stSearch.ticketId);
    if (stSearch.SearchTitle) newSearchObject.title = stSearch.SearchTitle;
    if (stSearch.SearchFrom)
      newSearchObject.fromTicketId = parseInt(stSearch.SearchFrom);
    if (stSearch.SearchTill)
      newSearchObject.toTicketId = parseInt(stSearch.SearchTill);
    if (stSearch.RegDateTime) newSearchObject.Date = stSearch.RegDateTime;
    if (stSearch.department) {
      if (stSearch.department.departmentId) {
        newSearchObject.refId = stSearch.department.departmentId.toString();
      } else if (stSearch.department.organizationId) {
        newSearchObject.refId = stSearch.department.organizationId.toString();
      }
    }
    if (stSearch.ticketId)
      newSearchObject.ticketId = parseInt(stSearch.ticketId);
    if (stSearch.TicketStatus)
      newSearchObject.Status = stSearch.TicketStatus.id === "1" ? true : false;
    if (stSearch.ImportanceAutoCompleteData)
      newSearchObject.importanceGrade = +stSearch.ImportanceAutoCompleteData.id;
    if (stSearch.TicketAnswerStatus && stSearch.TicketAnswerStatus.type) {
      newSearchObject.answerStatus = +stSearch.TicketAnswerStatus.id;
    }
    if (stSearch.Tag) {
      newSearchObject.tagId = stSearch.Tag.id;
    }
    if (
      stSearch.TicketOwnerCompany &&
      stSearch.TicketOwnerCompany.organizationId
    ) {
      newSearchObject.TicketOwnerCompany =
        +stSearch.TicketOwnerCompany.organizationId;
    }
    if (
      stSearch.TicketRecipientCompany &&
      stSearch.TicketRecipientCompany.organizationId
    ) {
      newSearchObject.TicketRecipientCompany =
        +stSearch.TicketRecipientCompany.organizationId;
    }
    if (multiStSearch.TicketRecipientCompany?.length) {
      newSearchObject.TicketRecipientCompany =
        multiStSearch.TicketRecipientCompany.map(
          (item) => +item.organizationId,
        );
    }
    if (multiStSearch.TicketOwnerCompany?.length) {
      newSearchObject.TicketOwnerCompany = multiStSearch.TicketOwnerCompany.map(
        (item) => +item.organizationId,
      );
    }

    console.log(newSearchObject);

    setStSearch((prev) => ({ ...prev, searchedObject: newSearchObject }));
    props.searchHandel(newSearchObject);
  };
  const clearStates = () => {
    setStSearch((prevState) => ({
      ...prevState,
      Clear: true,
    }));
    setStSearch((prevState) => ({
      ...prevState,
      UserReceiver: "",
      SearchCategory: "",
      TicketOwnerGroup: "",
      TicketCreatedUser: "",
      TicketRecipientGroup: "",
      TicketReceivingUser: "",
      TicketOwnerCompany: "",
      TicketRecipientCompany: "",
      Satisfaction: "",
      TicketVisibilityStatus: "",
      Importance: "",
      TicketStatus: "",
      SearchTitle: "",
      ImportanceAutoCompleteData: "",
      SearchFrom: "",
      SearchTill: "",
      Kind: "",
      RegDateTime: "",
      RegDateTimeTo: "",
      UpdateDate: "",
      UpdateDateTo: "",
      department: "",
      TicketAnswerStatus: "",
      ticketId: "",
      searchedObject: {},
      Tag: "",
    }));
    props.searchHandel({});
  };

  const setClear = useCallback((clearStates) => {
    setStSearch((prevState) => ({
      ...prevState,
      Clear: clearStates,
    }));
  }, []);

  return (
    <div className={`search-container ${props.elClass}`}>
      <div className="dv-input-group flexRow">
        <div
          className={`input-group flexRow autocompleteBox ${
            !showElement.includes("SearchCategory") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn">دسته بندی تیکت ها </div>
          {stCategory ? (
            <Autocomplete
              className="newTicket-item  search-width"
              options={stCategory}
              getOptionLabel={(options) => {
                return options.categoryName || "";
              }}
              renderInput={(params) => (
                <TextField
                  className="damage-type-input font-family-ticket-input"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  required
                />
              )}
              renderOption={function (props, option) {
                return (
                  <li {...props}>
                    {" "}
                    <span className="font-family-ticket">
                      {option.categoryName}
                    </span>{" "}
                  </li>
                );
              }}
              value={stSearch["SearchCategory"]}
              onChange={(e, newValue) => {
                setStSearch((prev) => ({
                  ...prev,
                  SearchCategory: newValue ? newValue : null,
                }));
              }}
            />
          ) : (
            ""
          )}
        </div>
        <div
          className={`input-group mRight flexRow ${
            !showElement.includes("SearchTitle") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn">کلمه کلیدی در عنوان</div>
          <input
            type="text"
            name="keyword"
            className="input-group-text font-family-ticket"
            onChange={(e) => {
              setStSearch((prevState) => ({
                ...prevState,
                SearchTitle: e.target.value,
              }));
            }}
            value={stSearch.SearchTitle}
          />
        </div>
        <div
          className={`input-group mRight flexRow ${
            !showElement.includes("SearchFrom") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn">از شماره </div>
          <input
            type="number"
            name="keyword"
            className="input-group-text font-family-ticket"
            onChange={(e) => {
              setStSearch((prevState) => ({
                ...prevState,
                SearchFrom: e.target.value,
              }));
            }}
            value={
              stSearch.SearchFrom && stSearch.searchedObject["SearchFrom"] != ""
                ? (stSearch.searchedObject["SearchFrom"] = stSearch.SearchFrom)
                : ""
            }
          />
        </div>
        <div
          className={`input-group mRight flexRow ${
            !showElement.includes("SearchTill") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn">تا شماره </div>
          <input
            type="number"
            name="keyword"
            className="input-group-text font-family-ticket"
            onChange={(e) => {
              setStSearch((prevState) => ({
                ...prevState,
                SearchTill: e.target.value,
              }));
            }}
            value={
              stSearch.SearchTill && stSearch.searchedObject["SearchTill"] != ""
                ? (stSearch.searchedObject["SearchTill"] = stSearch.SearchTill)
                : ""
            }
          />
        </div>
        <div
          className={`input-group mRight flexRow ${
            !showElement.includes("RegDateTime") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn">تاریخ ایجاد </div>
          <input
            name="keyword"
            placeholder="____/__/__"
            className="input-group-text ltr font-family-ticket"
            onChange={(e) => {
              const inputText = e.target.value;
              //const formattedText = formatDate(inputText);
              setStSearch((prevState) => ({
                ...prevState,
                RegDateTime: inputText,
              }));
            }}
            value={stSearch.RegDateTime}
          />
        </div>

        <div
          className={`input-group flexRow ${
            !showElement.includes("TicketStatus") &&
            !showElement.includes("All")
              ? "none"
              : ""
          }`}
        >
          <div className="input-group-txt flexColumn">وضعیت تیکت </div>
          {props.stOrganizaton ? (
            <Autocomplete
              className="newTicket-item  search-width"
              options={TicketSearchStatus}
              getOptionLabel={(options) => {
                return options.title || "";
              }}
              renderInput={(params) => (
                <TextField
                  className="damage-type-input font-family-ticket-input"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  required
                />
              )}
              renderOption={function (props, option) {
                return (
                  <li {...props}>
                    {" "}
                    <span className="font-family-ticket">{option.title}</span>
                  </li>
                );
              }}
              value={stSearch["TicketStatus"]}
              onChange={(e, newValue) => {
                setStSearch((prev) => ({
                  ...prev,
                  TicketStatus: newValue ? newValue : null,
                }));
              }}
            />
          ) : (
            ""
          )}
        </div>

        <div
          className={`input-group flexRow autocompleteBox ${
            !showElement.includes("TicketRecipientCompany") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn">سازمان/شرکت گیرنده </div>
          {TicketSearchStatus ? (
            <Autocomplete
              multiple // 1. فعال کردن حالت انتخاب چندگانه
              className="newTicket-item search-width"
              options={props.stOrganizaton}
              getOptionLabel={(option) => option.title || ""}
              // 2. مدیریت ظاهر گزینه‌های انتخاب شده (فیلتر کردن برای راحتی کاربر)
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="damage-type-input font-family-ticket-input"
                  placeholder="انتخاب شرکت‌ها..."
                  required
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  <span className="font-family-ticket">{option.title}</span>
                </li>
              )}
              // 3. مقدار باید یک آرایه باشد
              value={stSearch["TicketRecipientCompany"] || []}
              onChange={(e, newValue) => {
                setMultiStSearch((prev) => ({
                  ...prev,
                  TicketRecipientCompany: newValue, // <-- آرایه
                }));
              }}
            />
          ) : (
            ""
          )}
        </div>
        <div
          className={`input-group flexRow autocompleteBox ${
            !showElement.includes("TicketOwnerCompany") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn">سازمان/شرکت فرستنده </div>
          {TicketSearchStatus ? (
            <Autocomplete
              multiple // 1. فعال کردن حالت انتخاب چندگانه
              className="newTicket-item search-width"
              options={props.stOrganizaton}
              getOptionLabel={(option) => option.title || ""}
              // 2. مدیریت ظاهر گزینه‌های انتخاب شده (فیلتر کردن برای راحتی کاربر)
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="damage-type-input font-family-ticket-input"
                  placeholder="انتخاب شرکت‌ها..."
                  required
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  <span className="font-family-ticket">{option.title}</span>
                </li>
              )}
              // 3. مقدار باید یک آرایه باشد
              value={stSearch["TicketOwnerCompany"] || []}
              onChange={(e, newValue) => {
                setMultiStSearch((prev) => ({
                  ...prev,
                  TicketOwnerCompany: newValue, // <-- آرایه
                }));
              }}
            />
          ) : (
            ""
          )}
        </div>
        <div
          className={`input-group flexRow ${
            !showElement.includes("Importance") && !showElement.includes("All")
              ? "none"
              : ""
          }`}
        >
          <div className="input-group-txt flexColumn">درجه اهمیت </div>
          {Importance ? (
            <Autocomplete
              className="newTicket-item  search-width"
              options={Importance}
              getOptionLabel={(options) => {
                return options.title || "";
              }}
              renderInput={(params) => (
                <TextField
                  className="damage-type-input font-family-ticket-input"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  required
                />
              )}
              renderOption={function (props, option) {
                return (
                  <li {...props}>
                    {" "}
                    <span className="font-family-ticket">{option.title}</span>
                  </li>
                );
              }}
              value={stSearch["ImportanceAutoCompleteData"]}
              onChange={(e, newValue) => {
                setStSearch((prev) => ({
                  ...prev,
                  ImportanceAutoCompleteData: newValue ? newValue : null,
                }));
              }}
            />
          ) : (
            ""
          )}
        </div>

        <div
          className={`input-group flexRow ${
            !showElement.includes("Tag") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn">تگ</div>

          <Autocomplete
            className="newTicket-item search-width"
            options={tags}
            getOptionLabel={(option) => option.title || ""}
            value={stSearch.Tag || null}
            onChange={(e, newValue) => {
              setStSearch((prev) => ({
                ...prev,
                Tag: newValue,
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                className="damage-type-input font-family-ticket-input"
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                <span className="font-family-ticket">{option.title}</span>
              </li>
            )}
          />
        </div>

        <div
          className={`input-group flexRow ${
            !showElement.includes("answerStatus") &&
            !showElement.includes("All")
              ? "none"
              : ""
          }`}
        >
          <div className="input-group-txt flexColumn"> وضعیت پاسخ تیکت </div>
          {TicketSearchStatus ? (
            <Autocomplete
              className="newTicket-item  search-width"
              options={TicketAnswerSearchStatus}
              getOptionLabel={(options) => {
                return options.title || "";
              }}
              renderInput={(params) => (
                <TextField
                  className="damage-type-input font-family-ticket-input"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  required
                />
              )}
              renderOption={function (props, option) {
                return (
                  <li {...props}>
                    {" "}
                    <span className="font-family-ticket">{option.title}</span>
                  </li>
                );
              }}
              value={stSearch["TicketStatus"]}
              onChange={(e, newValue) => {
                setStSearch((prev) => ({
                  ...prev,
                  TicketAnswerStatus: newValue ? newValue : null,
                }));
              }}
            />
          ) : (
            ""
          )}
        </div>
        <div
          className={`input-group mRight flexRow ${
            !showElement.includes("ticketId") ? "none" : ""
          }`}
        >
          <div className="input-group-txt flexColumn"> شماره تیکت </div>
          <input
            type="number"
            name="keyword"
            className="input-group-text font-family-ticket"
            onChange={(e) => {
              setStSearch((prevState) => ({
                ...prevState,
                ticketId: e.target.value,
              }));
            }}
            value={stSearch.ticketId || ""}
          />
        </div>
        {/*{!localStorage.getItem("refType") ?*/}
        {/*     <div*/}
        {/*    className={`input-group flexRow ${!showElement.includes("Satisfaction") &&*/}
        {/*        !showElement.includes("All")*/}
        {/*        ? "none"*/}
        {/*        : ""*/}
        {/*        }`}*/}
        {/*>*/}
        {/*    <div className="input-group-txt flexColumn">میزان رضایت :</div>*/}
        {/*    {*/}
        {/*        stSearch.SatisfactionAutoCompleteData &&*/}
        {/*        <AutoComplete Clear={stSearch.Clear} setClear={setClear} dataList={stSearch.SatisfactionAutoCompleteData} onInputChange={handleSatisfactionChange} forceChooseFromList={true} noOptionText={"موردی یافت نشد"} displayKey="value" idPrefix="autocomplete10" defaultValue="تست 1" />*/}
        {/*    }*/}
        {/*</div>*/}

        {/*: ''}*/}
        {/*<div*/}
        {/*    className={`input-group flexRow ${!showElement.includes("TicketVisibilityStatus") &&*/}
        {/*        !showElement.includes("All")*/}
        {/*        ? "none"*/}
        {/*        : ""*/}
        {/*        }`}*/}
        {/*>*/}
        {/*    <div className="input-group-txt flexColumn">وضعیت دیده شدن تیکت :</div>*/}
        {/*    {*/}
        {/*        stSearch.TicketVisibilityStatusAutoCompleteData &&*/}
        {/*        <AutoComplete Clear={stSearch.Clear} setClear={setClear} dataList={stSearch.TicketVisibilityStatusAutoCompleteData} onInputChange={handleTicketVisibilityStatusChange} forceChooseFromList={true} noOptionText={"موردی یافت نشد"} displayKey="value" idPrefix="autocomplete11" defaultValue="تست 1" />*/}
        {/*    }*/}

        {/*</div>*/}
      </div>

      <button
        onClick={getSearched}
        variant="contained"
        className="btn-primary searchBtnPrimery"
      >
        جستجو
      </button>
      <button onClick={clearStates} variant="contained" className="btn-default">
        تنظیمات اولیه
      </button>
      <h4 style={{ marginRight: "3%" }}>نتایج : {rowNum ? rowNum : 0} ردیف</h4>
    </div>
  );
}
